import script from "./LoginHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./LoginHeader.vue?vue&type=script&setup=true&lang=js"

import "./LoginHeader.vue?vue&type=style&index=0&id=824057ac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-824057ac"]])

export default __exports__